import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/bak/contracts/$subscriptionId/status')({
  component: () => (
    <Navigate replace search from="/bak/contracts/$subscriptionId/status" to="/bo/contracts/$subscriptionId/status" />
  ),
})
